import React, { Fragment } from 'react'
import { string, bool, func } from 'prop-types'

import Icon from './Icon/Icon'
import Tooltip from './Tooltip'

function InputCheckbox({
  id,
  checked = false,
  isDisabled = false,
  onChange,
  groupedBy = null,
  label = '',
  required = false,
  labelInfo = '',
}) {
  return (
    <Fragment>
      <input
        id={id}
        type="checkbox"
        className="checkbox"
        checked={checked}
        disabled={isDisabled}
        onChange={() => onChange(id, groupedBy)}
      />
      <label htmlFor={id}>
        <span dangerouslySetInnerHTML={{ __html: label }} />
        {required && <b> *</b>}
        {labelInfo && (
          <Tooltip
            id={`label-info-${id}`}
            content={labelInfo}
            className="checkbox__info"
          >
            <Icon type={['fas', 'question-circle']} />
          </Tooltip>
        )}
      </label>
    </Fragment>
  )
}

InputCheckbox.propTypes = {
  id: string.isRequired,
  label: string,
  checked: bool,
  onChange: func.isRequired,
  groupedBy: string,
  required: bool,
  labelInfo: string,
  isDisabled: bool,
}

export default InputCheckbox
